export const FieldsMetaData = [
  {
    QuestionID: "Q_FIRSTNAME",
    Datatype: "NAMETYPE",
  },
  {
    QuestionID: "Q_LASTNAME",
    Datatype: "NAMETYPE",
  },
  {
    QuestionID: "Q_DOB",
    Datatype: "DATETYPE",
  },
  {
    QuestionID: "Q_PHONE",
    Datatype: "PHONETYPE",
  },
  {
    QuestionID: "Q_PHONE_2",
    Datatype: "PHONETYPE",
  },
  {
    QuestionID: "Q_PHONE_TYPE",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_PHONE_TYPE_2",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_GENDER",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_ADDRESS1",
    Datatype: "ADDRESSLINETYPE",
  },
  {
    QuestionID: "Q_ADDRESS2",
    Datatype: "ADDRESSLINETYPE",
  },
  {
    QuestionID: "Q_CITY",
    Datatype: "CITYTYPE",
  },
  {
    QuestionID: "Q_STATE",
    Datatype: "STATECODETYPE",
  },
  {
    QuestionID: "Q_ZIP",
    Datatype: "ZIPTYPE",
  },
  {
    QuestionID: "Q_GOVT_PAID",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_COUNTRY",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_CONTACT_METHOD",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_EMAIL",
    Datatype: "EMAILTYPE",
  },
  {
    QuestionID: "Q_INSURANCE_TYPE",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_VEGZELMA",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_YUFLYMA",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_ADALIMUMAB",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_STEQEYMA",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_STOBOCLO",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_OSENVELT",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_AVTOZMA",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_OMLYCLO",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_INDICATION_ZYMFENTRA",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_PHYSICIAN_FIRSTNAME",
    Datatype: "NAMETYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_LASTNAME",
    Datatype: "NAMETYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_ADDRESS_1",
    Datatype: "ADDRESSLINETYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_ADDRESS_2",
    Datatype: "ADDRESSLINETYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_CITY",
    Datatype: "CITYTYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_STATE",
    Datatype: "STATECODETYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_ZIP",
    Datatype: "ZIPTYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_PHONE",
    Datatype: "PHONETYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_FAX",
    Datatype: "PHONETYPE",
  },
  {
    QuestionID: "Q_NPI",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_TIN",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_HIPAA_CONSENT",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_PAT_CONSENT",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_TEXT_OPT_IN",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_HIPAA_PATIENT_RELATIONSHIP",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_HIPAA_DATE_TIME",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_CAM_ID",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_BENEFIT_TYPE",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_DRUG",
    Datatype: "STRING",
  },
  {
    QuestionID: "Q_AGE_18",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_PHYSICIAN_CONSENT",
    Datatype: "YESNOTYPE",
  },
  {
    QuestionID: "Q_ENROLLER_TYPE",
    Datatype: "STRING",
  },
];
